module.exports = __webpack_public_path__ + "static/media/offers-orange.791d5011.svg";